import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Modal } from '@resy/ui-kitchen';

import TockExperienceOptions from './TockExperienceOptions';
import { closeTockExperienceModal, openTockExperienceOffering } from '../../../../../ui-kitchen/src/reducers/tockExperienceSlice';
import openTockUrl from '../../../../../ui-kitchen/src/utils/openTockUrl';

const modalStyles = {
  content: {
    border: '1px solid #cacaca',
    borderRadius: '12px',
    inset: '30px 0 auto',
    maxHeight: '90vh',
    position: 'absolute',
    maxWidth: '760px',
    padding: 0,
    overflow: 'auto',
  },
};

const TockExperienceOptionsModal = ({
  isOpen,
  experiences,
  isMobile,
  selectedTime,
  selectedDate,
  selectedSeats,
  venueName,
  venueId,
  closeOptions,
  dispatch,
}) => {
  const handleClose = () => {
    closeOptions();
  };

  const handleBookSlot = (url) => {
    if (!url) return;
    openTockUrl(url, dispatch);
    closeOptions();
  };

  const handleOpenOffering = (experience, openOnMobile) => {
    dispatch(openTockExperienceOffering({
      selectedExperience: experience,
      isMobile: openOnMobile,
      selectedDate,
      selectedSeats,
      hasBackButton: true,
      venueId,
      venueName,
    }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      styles={modalStyles}
      shouldCloseOnOverlayClick
      className="TockExperienceOptionsModal"
    >
      <TockExperienceOptions
        experiences={experiences}
        isMobile={isMobile}
        selectedTime={selectedTime}
        selectedDate={selectedDate}
        selectedSeats={selectedSeats}
        venueName={venueName}
        onClose={handleClose}
        onBookSlotClick={handleBookSlot}
        handleOpenOffering={handleOpenOffering}
      />
    </Modal>
  );
};

TockExperienceOptionsModal.displayName = 'TockExperienceOptionsModal';

TockExperienceOptionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  experiences: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool,
  selectedTime: PropTypes.string,
  selectedDate: PropTypes.string,
  selectedSeats: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  venueName: PropTypes.string,
  venueId: PropTypes.number,
  closeOptions: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

TockExperienceOptionsModal.defaultProps = {
  experiences: [],
  isMobile: false,
  selectedTime: null,
  selectedDate: null,
  selectedSeats: null,
  venueName: null,
  venueId: null,
};

const mapStateToProps = (state) => {
  const slice = state.tockExperience;
  return {
    isOpen: !!(slice && slice.isOptionsOpen),
    experiences: (slice && slice.experiences) || [],
    isMobile: (slice && slice.isMobile) || false,
    selectedTime: (slice && slice.selectedTime) || null,
    selectedDate: (slice && slice.selectedDate) || null,
    selectedSeats: (slice && slice.selectedSeats) || null,
    venueName: (slice && slice.venueName) || null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  closeOptions: () => dispatch(closeTockExperienceModal()),
});

export { TockExperienceOptionsModal };
export default connect(mapStateToProps, mapDispatchToProps)(TockExperienceOptionsModal);
